module.exports = __webpack_public_path__ + "media/images/icons/dropdown_purple-fb9bcde8b10188a140946b477ccc13e2.svg";